namespace RedBullMOBILE360.LoanWhitelist {
    export interface LoanWhitelistForm {
        Msisdn: Serenity.StringEditor;
    }

    export class LoanWhitelistForm extends Serenity.PrefixedContext {
        static formKey = 'LoanWhitelist.LoanWhitelist';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!LoanWhitelistForm.init)  {
                LoanWhitelistForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(LoanWhitelistForm, [
                    'Msisdn', w0
                ]);
            }
        }
    }
}
